module.exports = __webpack_public_path__ + "img/taiwan_2.5cfb9000.png";